import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Icon, Input, Popover,
} from 'antd';
import {
  Box, Flex, ShowIf, Text,
} from '../../../shared/components';

export default class PopoverEditorNumero extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      visible: false,
      numeroModificado: null,
    };
  }

  cancelar() {
    const { onCancelar } = this.props;
    this.hide();
    if (onCancelar && typeof onCancelar === 'function') onCancelar();
  }

  aplicar() {
    const { onAplicar } = this.props;
    const { numeroModificado } = this.state;
    this.hide();
    if (onAplicar && typeof onAplicar === 'function') onAplicar({ valor: numeroModificado });
  }

  hide() {
    this.setState({ visible: false });
  }

  init() {
    const { numero } = this.props;
    if (numero) this.setState({ numeroModificado: numero });
  }

  render() {
    const { visible, numeroModificado } = this.state;
    const { numero, title, label } = this.props;
    const tieneValor = numero !== undefined && numero !== null;
    return (
      <Popover
        onVisibleChange={() => this.init()}
        overlayClassName="no-padding"
        title={title}
        trigger="click"
        visible={visible}
        content={(
          <Box p="16">
            <Text mb="8">Nº</Text>
            <Input
              value={numeroModificado}
              onChange={e => this.setState({ numeroModificado: e.target.value })}
              onPressEnter={() => this.aplicar()}
            />
            <Box style={{ textAlign: 'right' }}>
              <Box pt="16" display="inline-block">
                <Button
                  style={{ marginRight: '8px' }}
                  onClick={() => this.cancelar()}
                  size="small"
                >
                  <Text translationId="generico.cancelar" />
                </Button>
                <Button
                  onClick={() => this.aplicar()}
                  size="small"
                  type="primary"
                >
                  <Text translationId="generico.aplicar" />
                </Button>
              </Box>
            </Box>
          </Box>
          )}
      >
        <Button
          type="link"
          style={{ padding: 0, height: 'auto', width: '100%' }}
          onClick={() => this.setState({ visible: true })}
        >
          <Flex width="100%" justifyContent="space-between">
            { tieneValor ? <Text ml="4" fontSize="12">{ numero }</Text> : label }
            <Icon style={{ fontSize: '12px' }} type="down" />
          </Flex>
        </Button>
      </Popover>
    );
  }
}

PopoverEditorNumero.propTypes = {
  numero: PropTypes.string,
  onAplicar: PropTypes.func,
  onCancelar: PropTypes.func,
  title: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired,
};

PopoverEditorNumero.defaultProps = {
  numero: null,
  onAplicar: null,
  onCancelar: null,
};
